import React from 'react';

import { Skeleton } from '../../../../components';
import type { StatsKpi } from '../../../../mock-data/types';
import { LiveNumber } from '../LiveNumber';
import { Delta } from '../Delta';
import { Grid, Tile, TileLabel, TileValue, TileFooter, TileVs } from './OperationalKpis.styles';

export type OperationalKpisProps = {
  kpis: StatsKpi[];
  /** While true, the figures + deltas show placeholders (the endpoint is loading). */
  loading?: boolean;
};

/** "Operational Performance" — the KPI tiles (Active Players, Player Average Wager,
 *  Live RTP), each a label + figure + delta / caption footer. The label is static
 *  chrome; the figure + delta load in. A placeholder tile (`?` not wired, `N/A` the
 *  API is failing, `–` undefined this period) drops its delta/caption footer (no
 *  comparison to show). */
export const OperationalKpis = ({ kpis, loading = false }: OperationalKpisProps): React.ReactElement => (
  <Grid>
    {kpis.map((k) => {
      const placeholder = Boolean(k.missing || k.error || k.indeterminate);
      return (
        <Tile key={k.id}>
          <TileLabel text={k.label} tag="span" />
          <TileValue>
            <LiveNumber
              value={k.value}
              prefix={k.prefix}
              suffix={k.suffix}
              decimals={k.decimals}
              loading={loading}
              missing={k.missing}
              error={k.error}
              indeterminate={k.indeterminate}
            />
          </TileValue>
          {placeholder ? null : (
            <TileFooter>
              {loading ? <Skeleton width={44} height={16} radius={6} /> : <Delta delta={k.delta} size={13} />}
              <TileVs text={k.vs} tag="span" />
            </TileFooter>
          )}
        </Tile>
      );
    })}
  </Grid>
);

export default OperationalKpis;
